module.exports = __webpack_public_path__ + "img/appropriate_stats.41ef0197.png";